
import { useEffect } from 'react';

import { useNavigate, useLocation } from "react-router-dom";
import { JoyyaHeader } from '../../../../components/JoyyaHeader';

import {
    Search,
    Image,
    List,
    Message,
    Icon,
    Header,
} from 'semantic-ui-react'

import { useQuery } from '@apollo/client';
import { useCallback, useRef, useState } from "react";

import styles from './TeacherPeopleView.module.css';

import { GET_PEOPLE } from '../data/GET_PEOPLE';

const TeacherPeopleView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const urlSearchParams = new URLSearchParams(location.search);
  const [search, setSearch] = useState(urlSearchParams.get('search') || "");
  const [hasSearched, setHasSearched] = useState(false);
  const { loading , error , data, refetch } = useQuery(GET_PEOPLE, { variables: { search } });

  const timeoutRef = useRef();

  const handleSearchChange = useCallback((_: any, data: any) => {
    if (!hasSearched) setHasSearched(true)
    clearTimeout(timeoutRef.current)
    setSearch(data.value)

    // @ts-ignore
    timeoutRef.current = setTimeout(() => {
      navigate({ pathname: location.pathname, search: `?search=${data.value}` });
      refetch({ search: data.value });
    }, 500)
  }, [refetch, timeoutRef, hasSearched])

  // On path change from broswer back button, we need to update the search state
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const searchParam = params.get('search');
    if (searchParam === null) {
      // If no search param, reset search state
      setSearch("");
      setHasSearched(false);
      refetch({ search: "" });
    } else if (searchParam !== null && searchParam !== search) {
      setSearch(searchParam);
      setHasSearched(true);
      refetch({ search: searchParam });
    }
  }, [location.search, refetch]);


  const shouldShowSearch = ((data != null && data.users.length > 10) || search.length > 0 || hasSearched)

  return (
      <>
        <JoyyaHeader />
          <div className='mobile-frame'>
            <Header as='h2'>
              <span className={styles.header}>
                <Icon name='arrow left' className={styles.pointer} onClick={() => navigate(-1)} />
                People
              </span>
            </Header>
          { shouldShowSearch && <Search
             loading={loading}
             input={{ fluid: true }}
             className={styles.search}
             size='large'
             placeholder='Search...'
             open={false}
             onSearchChange={handleSearchChange}
             value={search}
          />}
          <List>
          { !loading && !error && data != null && data.users.map((p: any) => (
            <List.Item className={styles.item} style={{cursor: 'pointer'}} key={p.id} onClick={() => navigate(`/people/${p.id}`)}>
              <Image className={styles.image} avatar src={p.photoUrl} size='tiny' style={{ width: '5em', height: '5em', objectFit: 'cover' }}/>
              <List.Content>
                <List.Header className={styles.personName}>{`${p.name}`} ({`${p.identifier}`})</List.Header>
                <List.Description>
                  <span className={styles.scriptName}>
                      {p.scriptName} {`${p.preferredName !== '' ? '(' + p.preferredName + ')' : ''}`}
                  </span>
                </List.Description>
              </List.Content>
            </List.Item>
          ))}
          </List>
          { shouldShowSearch && !loading && !error && data != null && data.users.length > 10
            && <><Message>
            <Message.Header>Don't see the person you are looking for?</Message.Header>
            <p>We don't load everyone at once, try another search</p>
            </Message>
            <br/>
            <br/></>
          }
        </div>
      </>
  )
}

export { TeacherPeopleView }
